<footer class="bg--dimGreen pt-10 flex justify-center">
  <div class="lg:grid lg:grid-cols-3 flex flex-col items-center xl:w-8/12 pt-16 pb-8">
    <div class="flex flex-col items-center mb-6 lg:mb-0 lg:items-start">
      <p class="text-white font-black border-text pb-1 text-xl mb-4">دسترسی سریع :</p>
      <ng-container *ngFor="let item of linksItem">
        <a rel="follow" [href]="item.link" class="bg-[#918f8ff0] py-2  px-4 rounded-lg my-1">
          <p class="text-white font-medium">{{item.name}}</p>
        </a>
      </ng-container>
    </div>
    <div class="flex-col items-center mb-6 lg:mb-0 flex h-full justify-end">
      <ul aria-label="دسترسی ها" class="max-lg:text-center flex flex-col items-center">
        <!-- <li><a href="mailto:support@IraniExpert.com">support&#64;IraniExpert.com</a></li> -->
        <!-- <li class="my-1 text-white" dir="ltr"><a rel="nofollow" href="tel:+989150502016">+98 915 050 2016</a></li> -->
        <li class="my-1 text-white" dir="ltr"><a rel="nofollow" href="tel:+989150502016">+98 915 050 2016</a></li>
        <li class="my-1 text-white" dir="ltr"><a rel="nofollow" href="tel:+989150502018">+98 915 050 2018</a></li>
        <li class="my-1"><p class="text-white">هر روز هفته از 10:30 تا 18</p></li>
     </ul>
     <ul aria-label="شبکه‌های اجتماعی" class="flex max-lg:justify-center mt-4">
      <ng-container *ngFor="let item of socialItem">
        <li>
          <a class="w-full h-full" target="_blank" [href]="item.link" rel="nofollow">
            <img
              class="w-11 h-11 object-contain aspect-square m-1"
              loading="lazy"
              [title]="item.title"
              [src]="item.src"
              [alt]="item.alt"
              width="20"
              height="25"/>
          </a>
        </li>
      </ng-container>
    </ul>
    </div>
    <div class="flex flex-col items-end h-full justify-end">
      <a rel="follow" href="https://www.iraniexpert.com/">
        <img
          loading="lazy"
          title="Irani Expert - ایرانی اکسپرت"
          class="w-44 object-contain"
          src="../../../assets/img/logo-footer.webp"
          alt="IRaniExpert-logo"
          width="20"
          height="25"/>
      </a>
      <p class="text-justify text-white mt-8 font-medium w-64">
        ایرانی اکسپرت مفتخر است اعلام کند در دو فاز فعالیت دارد
        فاز اول تولید و توسعه ابزارهای معاملاتی، فاز دوم فروشگاه اکسپرت برای همکاران تولید کننده ربات که
        محصولات شان را بر بستر فروشگاه ما عرضه کنند.
        <br>
        هریک ازین دو فاز توسط تیمی متخصص درحال اجراست که کیفیت هریک در سطح بین المللی درحال رشد و توسعه است.
      </p>
    </div>
  </div>
</footer>